<template>
	<div class="ReChatSmall mb-1">
        <div  class="ReChatSmall_wrapper">

            <div class="chat-photo">
                <img :src="groupIcon" alt class="avatar" />
            </div>
            <div class="leftCol">
                <div class="title_row">
                    <div class="title"><i class="tim-ic ic-group mr-2 text-primary"></i><p>{{title}}</p></div>  <!--если группа Иконка отображается, если чат с чел-ом, то нет -->
                    <!--div class="title"><i class="d-inline-block fas fa-users text-primary mr-2 mt-1"></i><p>{{title}}</p></div--> 
                    <div class="date"><span>10.05.20</span></div>             
                </div>
                <div class="message_row">
                    <div class="message"><p>{{message}}</p></div>
                    <span class="badge badge-pill badge-primary ml-2">200+</span>                
                </div>
            </div>

        </div>
	</div>
</template>

<script>

export default {
    name: 'ReChatSmall',
    components: {

    },
    props: {
        counter: String,
        findId: {
            type: String,
            default: '',
        },
        groupIcon: {
            type: String,
            default: "/img/icons/icon-channel.svg"
        },
        title: {
            type: String,
            default: "Название чата"
        },
        message: {
            type: String,
            default: "Текст сообщения ааа ааа аааа аааааааааа аааа аааа ааа аа ааа"
        },
    },
    data () {
        return {
            ver: 1,
        }
    },
    computed: {

    },
    methods: {

    },
}
</script>
<style scoped>
.ReChatSmall_wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.chat-photo {margin: 0 15px;}
.chat-photo .avatar {
  min-width: 40px;
  min-height: 40px;
  margin-bottom: 0;
  background-color: transparent;
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
}
.leftCol {
  display: flex;
  flex-direction: column;
  flex-grow: 1; 
  padding: 5px 15px 0 0; 
}
.leftCol .title, .leftCol .message, .title_row, .message_row {display: flex;}
.title_row, .message_row {justify-content: space-between;}
.leftCol .message p {overflow: hidden; height: 25px;  text-overflow: ellipsis;}
.message_row .badge {max-height: 20px;}
.title_row .date span {color: inherit;}
.ReChatSmall:hover {
    background-color: rgba(1, 176, 224, 0.25);
    cursor: pointer;
}
.title i {font-size: 18px;}
.title_row .title {align-items: center;}

</style>
